import { jsx as _jsx } from "react/jsx-runtime";
import { alpha, Chip, styled } from '@mui/material';
import ActiveStateIcon from '@ui/components/icons/active-state';
import OfflineStateIcon from '@ui/components/icons/offline-state';
const StyledChip = styled(Chip)(({ theme }) => ({
    borderRadius: 16,
    backgroundColor: theme.palette.mode === 'light' ? '#f5f5f5' : alpha(theme.palette.grey[500], 0.12),
    color: theme.palette.text.primary,
    fontWeight: 500,
    paddingLeft: '4px',
    paddingRight: '4px',
    '& .MuiChip-label': {
        paddingLeft: 8
    }
}));
export const StatusChip = ({ status }) => {
    return (_jsx(StyledChip, { size: 'medium', label: status === 'Active' ? 'Active' : 'InActive', icon: status === 'Active' ? (_jsx(ActiveStateIcon, { width: 24, height: 24 })) : (_jsx(OfflineStateIcon, { width: 24, height: 24 })), variant: 'soft' }));
};
